import { getOwnedWidget } from "@/api/widgets";
import { captureException } from "@sentry/react";
import { LoaderFunctionArgs, redirect, replace } from "react-router-dom";
import { object, string } from "zod";

export async function WidgetPreviewLoaderLoader({
  params,
}: LoaderFunctionArgs): Promise<never> {
  try {
    const { widgetId } = object({ widgetId: string().nanoid() }).parse(params);
    const { public_key, name } = await getOwnedWidget(widgetId);
    throw redirect(`/preview?app_secret=${public_key}&selection=${name}`);
  } catch (error) {
    if (error instanceof Response) throw error;
    console.error(error);
    captureException(error);
  }
  throw redirect(window.location.pathname);
}
